// client/src/components/NFT/CollectionList.js
import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { getCollections } from './api';
import './CollectionList.css';

const CollectionList = ({ onSelectCollection, onRegisterClick, onBack }) => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCollections();
  }, []);

  const loadCollections = async () => {
    try {
      setLoading(true);
      setError('');
      const result = await getCollections();
      setCollections(result.collections || []);
    } catch (err) {
      setError(err.error || '컬렉션 목록을 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="collection-list-container">
        <div className="loading">컬렉션 목록을 불러오는 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="collection-list-container">
        <div className="error-message">{error}</div>
        <button onClick={loadCollections} className="retry-btn">다시 시도</button>
      </div>
    );
  }

  if (collections.length === 0) {
    return (
      <div className="collection-list-container">
        {onBack && (
          <button onClick={onBack} className="back-btn">
            <ArrowLeft className="icon" />
            <span>뒤로가기</span>
          </button>
        )}
        <div className="empty-message">
          <p>등록된 컬렉션이 없습니다.</p>
          <p>먼저 NFT를 등록해주세요.</p>
          <button onClick={onRegisterClick} className="register-btn">
            ➕ NFT 등록하기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="collection-list-container">
      <div className="collection-list-header">
        <div className="header-left">
          {onBack && (
            <button onClick={onBack} className="back-btn">
              <ArrowLeft className="icon" />
              <span>뒤로가기</span>
            </button>
          )}
          <h2>컬렉션 목록</h2>
        </div>
        <button onClick={onRegisterClick} className="register-btn">
          ➕ NFT 등록
        </button>
      </div>
      <div className="collection-grid">
        {collections.map((collection) => (
          <div 
            key={collection}
            className="collection-card-manage"
            onClick={() => onSelectCollection(collection)}
          >
            <div className="collection-icon">📦</div>
            <h3>{collection}</h3>
            <p>클릭하여 NFT 보기</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CollectionList;